import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/partners/profile/loading';

export const Route = createFileRoute('/_private/settings/partners/$id')({
  pendingComponent: Loading,
});
